{
  "default_title": "Unlock more features",
  "default_body": "Update to SparkLayer Core Script version {version} or later to unlock {feature}."
}
